/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactlawyerhandofftimesaved4Inputs */

const en_artifactlawyerhandofftimesaved4 = /** @type {(inputs: Artifactlawyerhandofftimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves the 30-min "tell me your case" meeting at lawyer hourly rates`)
};

const pt_artifactlawyerhandofftimesaved4 = /** @type {(inputs: Artifactlawyerhandofftimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poupa a reunião de 30 min de "conte-me o seu caso" paga à hora a um advogado`)
};

/**
* | output |
* | --- |
* | "Saves the 30-min \"tell me your case\" meeting at lawyer hourly rates" |
*
* @param {Artifactlawyerhandofftimesaved4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactlawyerhandofftimesaved4 = /** @type {((inputs?: Artifactlawyerhandofftimesaved4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactlawyerhandofftimesaved4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactlawyerhandofftimesaved4(inputs)
	return pt_artifactlawyerhandofftimesaved4(inputs)
});
export { artifactlawyerhandofftimesaved4 as "artifactLawyerHandoffTimeSaved" }